import React, { useState } from 'react'
import Theme from '../../../../../Theme'

type Props = {
    name: string
    position: { x: number, y: number }
    selectedLocation: string | null
    openPopup: () => void
}

const transition = 'all 150ms ease-in-out'
export default function Hotspot({ position, name, openPopup, selectedLocation }: Props) {
    const [onHover, setHover] = useState(false)
    const { x, y } = position

    let fillColor = Theme.colors.BrandOrange
    let shadowColor = Theme.colors.White
    if (!!selectedLocation && selectedLocation === name) {
        shadowColor = Theme.colors.BrandOrange
    } else if (!!selectedLocation && selectedLocation !== name) {
        fillColor = Theme.colors.BrandBlue
    }

    if (onHover)
        fillColor = Theme.colors.BrandOrange

    function onClickPotato(e: React.MouseEvent) {
        e.stopPropagation()
        openPopup()
        setHover(false)
    }
    return (
        <>
            <g
                style={{ cursor: 'pointer' }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={onClickPotato}
            >
                <circle
                    cx={x}
                    cy={y}
                    transform={`rotate(-22.451 ${x} ${y})`}
                    fill={shadowColor}
                    fillOpacity={0.4}
                    r={12.954}
                    filter={`url(#${name})`}
                />

                <circle
                    cx={x}
                    cy={y}
                    transform={`rotate(-22.451 ${x} ${y})`}
                    r={onHover ? 18.4 : 5.27}
                    fill={fillColor}
                    stroke={Theme.colors.White}
                    strokeWidth={onHover ? 0 : 0.478} />
                {
                    onHover && <text
                        opacity={0}
                        className='explore'
                        pointerEvents='none'
                        fontWeight='bold'
                        fontSize={16}
                        fill='white'
                        x={x}
                        y={y + 5}
                        letterSpacing='1.5px'

                    >
                        EXPLORE
                </text>}
            </g>
            <defs>
                <filter
                    id={name}
                    x={x - 14.87}
                    y={y - 12.958}
                    width={29.74}
                    height={29.74}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={1.912} />
                    <feGaussianBlur stdDeviation={0.956} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>


            </defs>

        </>
    )
}